export const isTrackCrossTrack = track => track.isCross
export const isSessionCrossTrack = session => session.track.isCross

export const isTrackWorkshop = track => track.isWorkshop



// WEBPACK FOOTER //
// ./src/app/predicates.js